<template style="height: 100%">
    <div class="ra mrt20 leftborder">
        <!--头部-->
        <div class="ml5">
            <span style="font-size: 16px;font-weight: bold">|</span>
            <span class="mrl20"  style="font-size: 16px; font-weight: bold">放映列表</span>
        </div>
        <div class="flex mrt20 ml5">
            <template>
                <el-date-picker
                        size="mini"
                        v-model="begin_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        style="width: 15%"
                        placeholder="选择日期">
                </el-date-picker>
                <span class=" middle" style="font-size: 14px">-</span>
                <el-date-picker
                        size="mini"
                        v-model="end_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        style="width: 15%"
                        placeholder="选择日期">
                </el-date-picker>
            </template>
            <template>
            <el-input class="mrl20" style="width: 15%" v-model="explain" placeholder="请输入" clearable size="mini"></el-input>
            <el-button class="mrl20" type="primary" @click="searchData"  :class="baseerp+'btn'" size="mini">查询</el-button>
            <el-button class="mrl20" type="primary" @click="addData"  :disabled="disabled" :class="baseerp+'btn'" size="mini" >+新增放映</el-button>
            </template>
        </div>
        <!--表单部分-->
        <div  class="tableHeight ml5">
            <el-table
                    ref="table"
                    class="mrt10"
                    size="mini"
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    @row-click="rowClick"
                    :highlight-current-row="highlightCurrentRow"
                    :show-header=false
                    :row-class-name="tableRowClassName">
                <el-table-column
                        prop="color"
                        label="标示"
                        width="40">
                    <template slot-scope="scope">
                        <div v-if="scope.row.color==3" style="width: 10px;height: 10px;border-radius: 50%;background-color: limegreen"></div>
                        <div v-if="scope.row.color==2" style="width: 10px;height: 10px;border-radius: 50%;background-color: orange"></div>
                        <div v-if="scope.row.color==1" style="width: 10px;height: 10px;border-radius: 50%;background-color: #9e9e9e"></div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="time"
                        label="时间"
                        width="180"
                        show-overflow-tooltip>
                    <template slot-scope="scope" >
                        <span>{{scope.row.dt_startTime}}</span>
                        <br>
                        <span style="color: #9e9e9e">-{{scope.row.dt_endTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="标题[说明]">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.color!='1'" style="color:#c37f00" >{{scope.row.i_type=="2"?"[图片]":"[视频]"}}</span>
                        <span v-else >{{scope.row.i_type=="2"?"[图片]":"[视频]"}}</span>
                        <span>{{scope.row.title}}</span>
                        <br>
                        <template v-for="(item, index) in scope.row.vcNameList">
                            <span style="color: #9e9e9e">{{item.vc_name+" ;"}}</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="pic"
                        label="图片"
                        width="200"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <template v-for="(item, index) in scope.row.contentList">
                            <img :src="item.vc_path" style="width:80px;height: 80px;margin-right: 3px;" v-if="scope.row.i_type=='2'"/>
                            <video :src="item.vc_path" style="width:80px;height: 80px;margin-right: 3px;" v-else controls="controls" ></video>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="num"
                        label="总数"
                        width="80">
                    <template slot-scope="scope" >
                        <span>共{{scope.row.num}}张</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                    <template slot-scope="scope">
                        <el-button @click="editData(scope.row)" style="border: none"  icon="el-icon-edit" circle  :disabled="scope.row.color==1?true:false"></el-button>
                        <el-button @click="delData(scope.row)" style="border: none" icon="el-icon-delete" circle :disabled="scope.row.color==1?true:false"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagetxt">
                <span>共{{tableTotal}}条，每页显示{{pageSize}}条</span>
            </div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="1000px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                    <add-schedule :application="application" @close="cancelDialog" @getArrangementList="getArrangementList"></add-schedule>
            </el-dialog>
        </div>

        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from  "../api";
    import axios from "axios";
    import addSchedule from "./addSchedule";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "showScheduleList",
        components:{addSchedule},
        props:{
            showschedule:{
                type:Object,
                required:true,

            }
        },
        mounted(){
            this.baseerp=baseerp;
            ///调用列表接口
            //this.getlist();
            // console.log(this.formvalue,"this.formvalue");
            // this.$nextTick(function () {
            //     this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            //
            //     // 监听窗口大小变化
            //     let self = this;
            //     window.onresize = function() {
            //         self.tableHeight = window.innerHeight - self.$refs.table.$el.clientTop - 280
            //     }
            //     // console.log(window.innerHeight,"H")
            // })
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度　

        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
        data(){
            return{
                groupid:"",
                showscheduleId:"",
                explain:"",
                ceshidata:[
                    {
                        "id":1,
                        "color":"1",
                        "type":"1",
                        "startime":"2022.06.07 9:30",
                        "endtime":"2022.06.08 11:30",
                        "title":"标题1",
                        "content":"电视机1,电视机2,电视机3,电视机4,电视机5,电视机6,电视机7,电视机8,电视机9",
                        "pic":{0:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/A87FF679A2F3E71D9181A67B7542122C4/1653906906036.png",
                               1:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/E4DA3B7FBBCE2345D7772B0674A318D55/1654070497612.png",
                               3:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/A87FF679A2F3E71D9181A67B7542122C4/1653906906036.png"},
                        "num":"3",
                    },
                    {
                        "id":2,
                        "color":"2",
                        "type":"2",
                        "startime":"2022.06.07 9:30",
                        "endtime":"2022.06.08 11:30",
                        "title":"标题2",
                        "content":"电视机1,电视机2,电视机3,电视机4",
                        "pic":{0:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/A87FF679A2F3E71D9181A67B7542122C4/1653906906036.png",
                               1:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/E4DA3B7FBBCE2345D7772B0674A318D55/1654070497612.png",
                               },
                        "num":"2",
                    },
                    {
                        "id":3,
                        "color":"3",
                        "type":"1",
                        "startime":"2022.06.07 9:30",
                        "endtime":"2022.06.08 11:30",
                        "title":"标题3",
                        "content":"电视机1,电视机2,电视机3,电视机4",
                        "pic":{0:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/A87FF679A2F3E71D9181A67B7542122C4/1653906906036.png",

                        },
                        "num":"1",
                    }
                ],
                /***********************************/
                i_id:"",
                i_type:"",
                apptitle:"",
                bfapp:[],
                dialogVisible:false,
                title:"",
                begin_time:"",
                end_time:"",
                tableData:[],
                pageSize:10,
                currentPage:1,
                tableTotal:0,
                vcName:"",
                application:{},
                highlightCurrentRow:false,
                disabled:false,
                baseerp:"",
                mid:0,
                tableHeight:0,
            }
        },
        watch:{
            showschedule:{
                handler(){
                    if (this.showschedule.value){
                        //console.log("父index给到子列表",this.showschedule);
                        if (this.showschedule.value.i_groupId ){
                            this.showscheduleId=this.showschedule.i_id;
                            this.groupid=this.showschedule.value.i_groupId;
                            //console.log(this.groupid,"groupid");
                            this.getArrangementList();
                        }
                    }
                },
                immediate:true,
                deep:true
            },

        },

        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 300;
            },
            //当前行color==3 整行灰掉
            tableRowClassName({row,rowIndex}){
                //console.log(row.id,"id");
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.color == 1) {

                    return 'danger-row';
                }
            },

            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.application.i_pid=row.i_pid;
                // console.log(this.application,"this.application",this.application.i_pid)
            },

            //关闭dialog
            cancelDialog(val){
                //console.log(val,"val,,,,,,");
                this.application.i_pid="";
                this.dialogVisible=false;
                //  console.log(this.application.i_pid,"cancelDialog");
                this.highlightCurrentRow=false;
            //    this.getArrangementList(val);
            },

            //点击编辑
            editData(row){
                this.title="编辑放映";
                this.dialogVisible=true;
                this.application={
                   i_id:row.id,
                   value:row,
                   schedule:this.showschedule,
                };
                //console.log(this.application,"editData");
                /*if (this.application.i_pid==""||this.application.i_pid==undefined){
                    //  console.log(this.application,"this.application",this.application.i_pid);
                    this.dialogVisible=false;
                    this.$message.error("请选择要编辑的行内容！")
                }else{
                    this.application={
                        i_pid:this.application.i_pid,
                        page_size:this.currentPage,
                        value:this.bfapp,
                        i_id:this.i_id,
                        i_type:this.i_type,
                        title:this.title,
                        i_mid:this.mid,
                    };
                    //  console.log(this.application,"editData");
                    this.dialogVisible=true;
                }*/

            },

            //点击删除
            delData(row){
                //console.log("row",row);
                this.showId=row.i_id;
                this.delArrangement();
            },

            //点击添加
            addData(){
                this.title="新增放映";
                this.dialogVisible=true;
                this.application={
                    i_id:0,
                    schedule:this.showschedule,
                };
                /*if(this.formvalue.title==null||this.formvalue==null){
                    this.dialogVisible=false;
                    this.$message.error("请选择要的添加左侧单！")
                }else{
                    this.title="添加申请单";
                    this.highlightCurrentRow=false;
                    this.application={
                        i_pid:0,
                        page_size:1,
                        value:this.bfapp,
                        i_id:this.i_id,
                        i_type:this.i_type,
                        title:this.title,
                        i_mid:this.mid,
                    };
                    // console.log(this.application,"addData");
                    this.dialogVisible=true;
                }*/

            },


            //点击查询
            searchData(){
                //console.log(this.explain,this.begin_time,this.end_time,"searchData");
                ///调用列表接口
                this.getArrangementList();
            },

            //列表接口
            async getArrangementList(pageSize){
                if(pageSize!=undefined) {
                    // console.log(pageSize,"pageSize");
                    this.currentPage=pageSize;
                }
                let param = {
                    i_groupId:this.groupid,
                    vc_id:this.showscheduleId,
                    i_pageNum:this.currentPage,
                    i_pageSize:10,
                    title:this.explain,
                    dt_startTime:this.begin_time,
                    dt_endTime:this.end_time,
                };
                let res = await API.getArrangementList(param);
                if (res.code == 1) {
                    this.tableData=res.arrangementList;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //删除
            async delArrangement(){
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    let param = {
                        i_id:this.showId,
                    };
                    let res = await API.delArrangement(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        //console.log(this.currentPage,"当前页");
                        this.getArrangementList(this.currentPage);
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                ///调用列表接口
                this.getArrangementList();
            },
        },
    }

</script>

<style lang="scss" scoped>

    .pagetxt{
        display: inline-block;
        padding: 6px 6px;
        font-size: 14px;
    }

    .ml5{
        margin-left:5px;
    }

    .leftborder{
        border-left: 1px solid #eee;
    }

    .ra{
        height: 100%;
    }

    .flex_search{
        justify-content: space-between;
    }

    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 6px;
    }
    .mrt20{
        margin-top: 10px;
    }
    .mrl20{
        margin-left: 10px;
    }
    .mrb40{
        margin-bottom: 60px;
    }
    /*.page{
        padding: 25px 15px;
    }*/
    .middle{
        line-height: 30px;
    }
    /*.tableHeight{
        min-height: 460px;
        height: 100%;
    }*/
    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }



        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    .cor37{
        color:#c37f00;
    }

    /deep/{
        .danger-row{
            color: #999 !important ;
        }
    }



</style>